export const EmailMeSupportedCountries = [
  // 'da-dk',
  'de-de',
  'en-au',
  'en-ca',
  'en-gb',
  'en-uk',
  'en-us',
  // 'es-es',
  'fr-fr',
  // 'it-it',
  'ja-jp',
  // 'pt-br',
  // 'nl-nl',
  // 'no-no',
  // 'sv-se',
];

// some locale not supported, need fallback to a support one
// https://msasg.visualstudio.com/Bing_Ads/_git/2a0621e5-d586-4a38-b076-25c5a266f61c?path=/private/Campaign/MT/Source/AdPreview/AdPreview.Library/ConsentUtil.cs
export const EmailMeFallbackLocale = {
  'en-uk': 'en-gb',
};
